import tracking from 'tracking';

const defaults = {
  popupWidth: 700,
  popupHeight: 500,
  buttonSelector: '[data-share-popup]'
};

class SocialLinks {

  constructor (element, settings) {
    this.shareButtons = element;
    this.options = Object.assign({}, defaults, settings);

    this.shareTriggers = element.querySelectorAll(this.options.buttonSelector);
    this.clickListener = this.clickEvent.bind(this);
  }

  createPopup (url) {
    const winTop = (window.screen.height / 2) - (this.options.popupHeight / 2);
    const winLeft = (window.screen.width / 2) - (this.options.popupWidth / 2);
    return window.open(url, 'sharer', [
      `top=${winTop}`,
      `left=${winLeft}`,
      `toolbar=0`,
      `status=0`,
      `width=${this.options.popupWidth}`,
      `height=${this.options.popupHeight}`
    ].join(','));
  }

  clickEvent (e) {
    e.preventDefault();
    this.createPopup(e.currentTarget.href);
    tracking.trackingEvent('socialShare', {
      network: e.currentTarget.getAttribute('data-network'),
      url: e.currentTarget.getAttribute('data-sharing-url')
    });
  }

  addLinksToTriggers () {
    [...this.shareTriggers].map((item) => {
      item.shareLink = item.href;
    });
  }

  removeLinksFromTriggers () {
    [...this.shareTriggers].map((item, index) => {
      delete item.shareLink;
    });
  }

  addEventListeners () {
    [...this.shareTriggers].map(item => {
      item.addEventListener('click', this.clickListener, false);
    });
  }

  removeEventListeners () {
    [...this.shareTriggers].map(item => {
      item.removeEventListener('click', this.clickListener, false);
    });
  }

  init () {
    this.addEventListeners();
  }

  destroy () {
    this.removeEventListeners();
  }
}

export default SocialLinks;
